import { z } from 'zod';
export const StopCaptureQueryRequestSchema = z.object({
    m: z.string(),
});
export const StopCaptureRequestSchema = StopCaptureQueryRequestSchema;
